import { Component, OnInit } from '@angular/core';
import {RestDataSource} from '../../model/rest.datasource';
import {Certificate} from '../../model/certificate.model';
import {Show} from '../../model/show.model';
import {LangRepository} from '../../model/lang.repository';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {TestModel} from '../../model/test.model';
import {environment} from '../../../environments/environment';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  public certificateSeries: number;
  public certificateNumber: number;
  public studentInfo: Certificate;
  public show: Show;
  isCertificateLoading: boolean = false;
  myForm: FormGroup;
  myFormIkt: FormGroup;
  myFormIin: FormGroup;
  loading: boolean = false;
  public yearCatalog: number[];
  public certificateSeriesCatalog: string[];
  public testType: TestModel[];


  private capchaSerial: boolean = true;
  private capchaIKT: boolean = true;

  private querySubscription: Subscription;

  constructor(
    private dateSource: RestDataSource,
    public langRepository: LangRepository,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.show = new Show('');

    this.myForm = new FormGroup({
          // serNumber: new FormControl(null, [Validators.required, Validators.minLength(2) ]),
          serSeries: new FormControl(null,   [Validators.required, Validators.minLength(7)])
    });

    this.myFormIkt = new FormGroup({
          ikt: new FormControl(null, [Validators.required, Validators.minLength(1)]),
          iin: new FormControl(null, [/*Validators.required, Validators.minLength(6)*/])
    });

    this.dateSource.testTypeCatalog()
      .subscribe(data => {
        this.testType = data;
      })

    this.dateSource.certificateSeriesCatalog()
      .subscribe(data => {
        this.certificateSeriesCatalog = data;
      })

    this.getTestYear(1);

    const testTypeId: string = this.route.snapshot.params['testTypeId'];
    const testYear: string = this.route.snapshot.params['testYear'];
    const studentId: string = this.route.snapshot.params['studentId'];
    const iin: string = this.route.snapshot.params['iin'];

    if (testTypeId && testYear && studentId && iin) {
      this.searchByIktFromRouteParams(testTypeId, testYear, studentId, iin);
    }
  }

  getTestYear(testId: string | number) {
    this.dateSource.testYearCatalog(+testId)
      .subscribe(data => {
        this.yearCatalog = data;
      })
  }

  errorMessage(text: string) {
       this.show.text = text;
     setTimeout(() => {
       this.show.text  = '';
     }, 5000)
  }

  searchByIkt(type: string, year: string) {
    if (!this.myFormIkt.invalid) {
      this.loading = true;
      if (isNaN(+this.myFormIkt.value.ikt)) {
        return this.errorMessage('Введите только число');
      }
      this.dateSource.getStudentDataByIkt(this.myFormIkt.value.ikt, this.myFormIkt.value.iin ? this.myFormIkt.value.iin : '', +type, +year)
        .subscribe(data => {
          this.studentInfo = data;
          // this.myFormIkt.reset();
          this.loading = false;

        }, error => {
          this.errorMessage(error.errorMessage.ru);
          this.studentInfo = null;
        })
    }
  }

  searchByIktFromRouteParams(type: string, year: string, ikt: string, iin: string) {
    this.loading = true;

    this.dateSource.getStudentDataByIkt(+ikt, iin, +type, +year)
      .subscribe(data => {
        this.studentInfo = data;
        this.myFormIkt.reset();
        this.loading = false;

      }, error => {
        this.errorMessage(error.errorMessage.ru);
        this.studentInfo = null;
      })
  }

  resolved(captchaResponse: string) {
    this.capchaSerial = true;
  }

  resolvedIKT(captchaResponse: string) {
    this.capchaIKT = true;
  }

  showCertificate(testTypeId: number, testYear: number, studentId: string, iin: string) {
    this.isCertificateLoading = true;

    this.dateSource.getCertificateDownloadLink(testTypeId, testYear, studentId, (iin ? iin : ''))
      .subscribe(
        data => {
          // window.open(data.certificateDownLoadUrl, '_blank');
           window.location.href = data.certificateDownLoadUrl;
          this.isCertificateLoading = false;
        },
        error => {
          this.errorMessage(error.errorMessage.ru);
          this.studentInfo = null;
          this.isCertificateLoading = false;
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Проекты/grant_results/src/app/search/search-form/search.component.ts